
import axios from "axios"
import { defineComponent, reactive, ref, toRaw } from "vue"
import { ElMessage } from "element-plus/es"

import { shortcuts } from "@/helpers/date"
import LangHelper from "@/helpers/lang"
import ResourceHelper from "@/helpers/resource"
import ReportHelper from "@/helpers/report"
import WrapperFooter from "@/views/wrapper/WrapperFooter.vue"

import { fields, parseData } from "./report"

import Preview from "../Preview.vue"
import { Icon } from "@iconify/vue"

export default defineComponent({
	components: {
		Icon,
		Preview,
		WrapperFooter
	},
	setup() {
		const floors = ref<any[]>([])
		const result = ref<any[]>([])
		const model = reactive<any>({
			floorId: null,
			name: ""
		})

		async function getRelatedData() {
			floors.value = await ResourceHelper.List("/building/floor")
		}

		getRelatedData()

		async function filterData() {
			result.value = []

			const { data: response } = await axios.post(
				"/report/tenant",
				toRaw(model)
			)

			const related = {
				floors: floors.value
			}
			const data = response.data.map((row: any) => parseData(row, related))

			if (data.length === 0)
				ElMessage.error(LangHelper.trans("message.tenant_not-found"))

			result.value = data
		}

		async function exportData() {
			if (result.value.length === 0)
				return ElMessage.error(
					LangHelper.trans("message.tenant_export_not-found")
				)

			ReportHelper.export(fields, result.value, "Tenant")
		}

		return {
			floors,
			result,
			model,
			shortcuts,
			fields,
			filterData,
			exportData
		}
	}
})
